import React from "react";
import { Description } from "./Description";

export const Projects = ({ projects }) => {
  return (
    <section className="projects-experience section" id="projects">
      <h2 className="section-title">Projects</h2>
      <div className="timeline">
        {projects.map((project) => (
          <Project key={`${project.company}-${project.name}`} {...project} />
        ))}
      </div>
    </section>
  );
};

const Project = ({ name, company, url, linkLabel, description }) => {
  return (
    <article className="timeline-item card">
      <div className="timeline-header">
        <span className="timeline-pill">{company}</span>
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="timeline-link"
          >
            {linkLabel || "View project"}
            <i className="bx bx-link-external" aria-hidden="true" />
          </a>
        ) : (
          <span className="timeline-subtitle">{linkLabel || "Private / internal project"}</span>
        )}
      </div>
      <h3 className="timeline-title">{name}</h3>
      <ul className="timeline-list">
        {description.map((desc, index) => (
          <Description key={index} desc={desc} />
        ))}
      </ul>
    </article>
  );
};